import { SET_ALERT } from './alert.type';

export const setAlert = (combination_id) => {
  return {
    type: SET_ALERT,
    payload: combination_id
  };
};
